import { Etablissement } from '@/models/Etablissement';
import { ActionTree, Action } from 'vuex';
import { EtabState, ETAB_STORE as s } from './types';
import { RootState } from '@/store/types';
import router from "@/router";
import api from "@/http/api";
import db from "@/db";

export const fetchListEtablissements: Action<EtabState, RootState>
    = ({ commit, dispatch, rootGetters }) => {
        return new Promise((resolve, reject) => {
            let listEtabUser = rootGetters.getCurrentUser.etablissement;

            let orderEtab = db.getEtablissements();

             orderEtab = orderEtab.filter((etab: Etablissement) => etab.getApplication() === "AN"
                    && listEtabUser.includes(etab.getId()))
                .sort(((a: Etablissement, b: Etablissement) =>
                    a.getNom().localeCompare(b.getNom())));
            commit(s.SET_LIST_ETAB, orderEtab);
            if (orderEtab.length == 1) {
                commit(s.SET_CURRENT_ETAB, orderEtab[0]);
                resolve("MonoEtab")
            }
            resolve("ListEtablissements")
        })
    }

export const selectEtablissement: Action<EtabState, RootState>
    = ({ commit }, etablissement: Etablissement) => {
        commit(s.SET_CURRENT_ETAB, etablissement);
        router.push("/home");
    }

export const actions: ActionTree<EtabState, RootState> = {
    fetchListEtablissements,
    selectEtablissement
};